import React, { useState } from 'react';
import { DollarSign } from 'lucide-react';
import FlujoCajaMovimientos from './FlujoCajaMovimientos';
import IngresosPage from './IngresosPage';
import EgresosPage from './EgresosPage';

const TABS = [
    { id: 'movimientos', label: 'Movimientos', component: FlujoCajaMovimientos },
    { id: 'ingresos', label: 'Ingresos', component: IngresosPage },
    { id: 'egresos', label: 'Egresos', component: EgresosPage }
];

const FlujoCajaPage = () => {
    const [activeTab, setActiveTab] = useState('movimientos');

    const ActiveComponent = TABS.find(tab => tab.id === activeTab)?.component;

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-center gap-3">
                    <div className="p-2 rounded-lg bg-emerald-500/20">
                        <DollarSign className="text-emerald-400" size={24} />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-white">Flujo de Caja</h1>
                        <p className="text-slate-400">Gestión completa de ingresos y egresos</p>
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div className="border-b border-slate-700">
                <div className="flex gap-2">
                    {TABS.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`
                px-6 py-3 font-medium transition-all relative
                ${activeTab === tab.id
                                    ? 'text-emerald-400 border-b-2 border-emerald-400'
                                    : 'text-slate-400 hover:text-white'
                                }
              `}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Content */}
            <div>
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};

export default FlujoCajaPage;
